var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOstLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 42,
    viewBox: "0 0 110 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3131_86)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.89333 7.0127H0V34.9878H6.89333V7.0127Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4992 0H6.89258V7.01243H27.4992V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3933 7.0127H27.5V34.9878H34.3933V7.0127Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1433 7.0127H41.25V14.0251H48.1433V7.0127Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1433 27.9756H41.25V34.988H48.1433V27.9756Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7141 0H48.1074V7.01243H68.7141V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7141 13.9873H48.1074V20.9997H68.7141V13.9873Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7141 34.9873H48.1074V41.9997H68.7141V34.9873Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6433 20.9629H68.75V34.9505H75.6433V20.9629Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5008 0H75.6074V7.01243H82.5008V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2859 20.9629H89.3926V41.9256H96.2859V20.9629Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3926 0V7.01243V13.9876H96.2492V7.01243H109.999V0H89.3926Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7859 34.9873H6.89258V41.9997H13.7859V34.9873Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5008 34.9873H20.6074V41.9997H27.5008V34.9873Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3131_86"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 42,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOstLogo);
export default __webpack_public_path__ + "static/media/OSTLogo.2c70675fb3d28e2560cd4755cd9ceeb6.svg";
export { ForwardRef as ReactComponent };